export default "__VITE_ASSET__CVN3cvKc__"